import { InternalAxiosRequestConfig } from 'axios';

export const secretHeaderInterceptor: (config: InternalAxiosRequestConfig) => InternalAxiosRequestConfig = (config) => {
  if (config.secret == null) {
    return config;
  }

  config.headers.set('X-Secret', config.secret);
  return config;
};
